// extracted by mini-css-extract-plugin
module.exports = {"loadMoreBtn":"news-module--loadMoreBtn--8YHrT","buttonRow":"news-module--buttonRow--2iyLm","buttonLink":"news-module--buttonLink--3drsD","chevron":"news-module--chevron--3Plhu"};